/* file description */
import { useMemo } from 'react';
import { MergeTableColumn } from '@/components/SEFieldWithModel/effects';
import { COLUMN_FROM, LCP_EFECT_KINDS } from '@/components/SEFieldWithModel/effects/consts';
import { useGetColumnByField } from '@/components/SEFieldWithModel/effects/useGetColumnByField';
import { UseXMColumnsProp } from './type';
import uploadUseRender from './component/UploadFile/effect/useRender';
import { getBizConfig } from '@/common/asset-apis/getAssetModuleByRequest';
import _ from 'lodash';

export const useColumnsProp: UseXMColumnsProp = ({
  mode,
  columns,
  moduleInfo,
  // rowKey,
  rowsData,
  fileConfig,
  setRowData,
  storeValue,
  store,
  isMobile,
}) => {
  const getColumnByField = useGetColumnByField({ isMobile });
  return useMemo(() => {
    let mergeColumns: MergeTableColumn[] = [];
    // let mergeRowKey = rowKey;
    // let primaryKey = '';
    const { fields = [] } = moduleInfo;
    // hashTable-一遍遍历处理
    const columnsHashTable: Record<any, any> = {};
    columns?.forEach((column) => {
      columnsHashTable[`${column.dataIndex}`] = column;
    });
    const columnsFields: Array<{
      [key: string]: any;
      options?: Record<any, any> | undefined;
    }> = [];


    const primaryKey = fields.find((x: any) => x.isPrimary)?.name;
    // 生成需要展示的columns，并排列
    columns?.forEach((column) => {
      const key = column.dataIndex;
      const field = fields?.find((x: any) => x.name === key);
      if (field) {
        const newField = _.cloneDeep(field);
        columnsFields.push(newField);

        // 执行规则变更业务组件元数据 规则生产的数据columnsHashTable[key].bizComponent，field模型中已经经过转化后的数据
        if (columnsHashTable[key].bizComponent) {
          const bizConfig = getBizConfig(columnsHashTable[key].bizComponent.componentsCode);
          console.log('Match to change BizConfig:', newField, columnsHashTable[key], bizConfig);
          newField.kind = bizConfig.kind;
          newField.bizConfig = Object.assign({}, bizConfig.options, columnsHashTable[key].bizComponent?.options);
          newField.extension = Object.assign({}, field.extension, {
            tooltip: columnsHashTable[key].bizComponent?.tooltip,
          });
        }

        // 处理RecordSelect联动显示字段
        if (field?.kind !== 'OpenApiSelect') {
          const { showFields = [], value: linkByFieldName } = ((field.bizConfig || field.options || {}) as { showFields: []; value: string });
          showFields?.forEach((showField: { key: any; realLabel: any; showModule: any; showModuleLabel: any; showModuleValue?: string }) => {
            columnsFields.push({
              kind: LCP_EFECT_KINDS.LINK_SHOW_RECORD,
              name: showField?.key,
              linkBy: field.name,
              label: showField?.realLabel,
              linkByFieldName,
              linkByLabel: field.label,
              linkByField: field,
              showModule: showField?.showModule,
              showModuleLabel: showField?.showModuleLabel,
              showModuleValue: showField?.showModuleValue,
              showNamespace: showField?.showNamespace,
              isImg: showField?.isImg,
            });
          });
        }
      }
    });

    // 字段render和renderFormItem生成，并以外部的render作为高优先级
    mergeColumns = columnsFields?.map((field) => {
      const newField = getColumnByField({
        mode,
        field,
        mergeColumn: columnsHashTable[field.name],
        moduleInfo,
        setRowData,
        storeValue,
        rowsData,
        store,
      });

      const column = columns?.find((x) => x.dataIndex === field.name);
      if (column) {
        Object.assign(newField, column);
      }
      return newField;
    });

    uploadUseRender({
      fileConfig,
      columns: mergeColumns,
    });

    return {
      mergeColumns: mergeColumns || [],
      // mergeRowKey: rowKey || mergeRowKey || 'recordID',
      primaryKey,
    };
  }, [moduleInfo, columns, fileConfig, rowsData]);
};
